import { boletoApi } from 'services/apiDigitalTicket/boleto';

/**
 * Get a temporary public URL for the boleto PDF, valid for 1 hour.
 * @param id the payment/charge request id (the boleto blob name)
 * @return the temporary URL, or '' when it could not be generated
 */
export const getBoletoUrl = async (id?: string): Promise<string> => {
  if (!id) {
    return '';
  }
  const response = await boletoApi.getUrl({ params: { id } });
  return response?.data?.url || '';
};

export default getBoletoUrl;
